import './Feature.scss'
import React, { useState } from 'react'
import { useMediaQuery } from '@material-ui/core'
import { ButtonArrow } from '@svort/component'
import { Translated, useTranslated } from '../../utils/translated'

import reg1 from './images/reg1.png'
import reg2 from './images/reg2.png'
import reg3 from './images/reg3.png'
import sign1 from './images/sign1.png'
import sign2 from './images/sign2.png'
import sign3 from './images/sign3.png'
import sign4 from './images/sign4.png'
import sign5 from './images/sign5.png'
import sign6 from './images/sign6.png'
import matching from './images/matching.png'
import document from './images/document.png'
import liveness from './images/liveness.png'

const Feature = (props) => {

    const translated = useTranslated();

    const [hover, setHover] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <div className='feature'>
            <div className='wrapper'>
                <div className='header-big'>
                    <p><Translated id='app.feature.title' /></p>
                </div>

                <div className='nav'>
                    <p className='section'>
                        <Translated id='app.feature.registration' />
                    </p>

                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/register2')}
                        onMouseEnter={() => !isMobile && setHover(2)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={reg2} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.registration-dots' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.registration-dots-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/register2')}
                            isHover={hover === 2} />
                    </div>
                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/register1')}
                        onMouseEnter={() => !isMobile && setHover(1)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={reg1} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.registration-sectors' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.registration-sectors-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/register1')}
                            isHover={hover === 1} />
                    </div>
                    <div className='nav-element last'
                        onClick={() => !isMobile && props.history.push('/feature/register3')}
                        onMouseEnter={() => !isMobile && setHover(11)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={reg3} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.registration-scale' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.registration-scale-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/register3')}
                            isHover={hover === 11} />
                    </div>

                    <p className='section'>
                        <Translated id='app.feature.login' />
                    </p>

                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/login2')}
                        onMouseEnter={() => !isMobile && setHover(4)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={sign2} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.login-dots' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.login-dots-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/login2')}
                            isHover={hover === 4} />
                    </div>
                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/login1')}
                        onMouseEnter={() => !isMobile && setHover(3)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={sign1} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.login-maze' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.login-maze-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/login1')}
                            isHover={hover === 3} />
                    </div>
                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/login3')}
                        onMouseEnter={() => !isMobile && setHover(8)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={sign3} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.login-emotions' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.login-emotions-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/login3')}
                            isHover={hover === 8} />
                    </div>
                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/login6')}
                        onMouseEnter={() => !isMobile && setHover(11)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={sign6} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.login-distortion' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.login-distortion-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/login6')}
                            isHover={hover === 10} />
                    </div>
                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/login4')}
                        onMouseEnter={() => !isMobile && setHover(9)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={sign4} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.login-loginless' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.login-loginless-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/login4')}
                            isHover={hover === 9} />
                    </div>
                    <div className='nav-element last'
                        onClick={() => !isMobile && props.history.push('/feature/login5')}
                        onMouseEnter={() => !isMobile && setHover(10)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={sign5} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.login-liveness' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.login-liveness-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/login5')}
                            isHover={hover === 10} />
                    </div>

                    <p className='section'>
                        <Translated id='app.feature.other' />
                    </p>

                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('init-action', { route: '/feature/document' })}
                        onMouseEnter={() => !isMobile && setHover(5)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={document} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.id-scan' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.id-scan-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('init-action', { route: '/feature/document' })}
                            isHover={hover === 5} />
                    </div>
                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/matching')}
                        onMouseEnter={() => !isMobile && setHover(6)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={matching} alt='loading...' />
                        <div className='title'>
                            <p><Translated id='app.feature.matching' /></p>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.matching-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/matching')}
                            isHover={hover === 6} />
                    </div>
                    <div className='nav-element'
                        onClick={() => !isMobile && props.history.push('/feature/liveness')}
                        onMouseEnter={() => !isMobile && setHover(7)}
                        onMouseLeave={() => !isMobile && setHover(false)}>
                        <img src={liveness} alt='loading...' />
                        <div className='title' style={{ marginTop: '22px' }}>
                            <p><Translated id='app.feature.flashes' /></p>
                            <div className='badge gray'>beta</div>
                        </div>
                        <p className='description'>
                            <Translated id='app.feature.flashes-desc' />
                        </p>
                        <ButtonArrow
                            text={translated('app.button.test')}
                            onClick={() => isMobile && props.history.push('/feature/liveness')}
                            isHover={hover === 7} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Feature
